import { Dispatch, ReactNode, SetStateAction } from "react";
import { InputHookResult } from "shared/hooks/useInputState";
import { Translations } from "shared/types/languages";

export type MetadataTagDetailsType = {
  loading: boolean;
  submitting: boolean;
  translations?: Translations;
  setTranslations: Dispatch<SetStateAction<Translations | undefined>>;
  errors: string;
  selectedTab: MetadataTagDetailsTabs;
  setSelectedTab: Dispatch<SetStateAction<MetadataTagDetailsTabs>>;
  onCloseTagDetails: () => void;
  metadataTagId: string | undefined;
  metadataTagDescription: InputHookResult;
  metadataTagName: InputHookResult;
  metadataTagTitle: string;
  metadataSecondaryTags: string[];
  allowTranslationSecondaryTags: boolean;
  onSubmitMetadataTag: () => void;
  onSubmitMetadataTagTranslation: () => void;
};

export type MetadataTagDetailsProviderProps = {
  children: ReactNode;
};

export type FormattedTagType = {
  id: string;
  name: string;
};

export enum MetadataTagDetailsTabs {
  General,
  Translations,
}

export enum ManagedTranslations {
  PrimaryTagName = "Primary tag",
  SecondaryTagName = "Secondary tag"
}